import { computed, ref } from "vue";
import groupsApi from "@/api/groups";

const invitations = ref([]);
const loading = ref(false);
const error = ref("");
let loaded = false;

export const useInvitations = () => {
  const count = computed(() => invitations.value.length);

  const load = async (force = false) => {
    if (loaded && !force) return;
    loading.value = true;
    error.value = "";
    const res = await groupsApi.listMyInvitations();
    loading.value = false;
    if (res?.error) {
      error.value = res.error.message;
      return;
    }
    invitations.value = res.data ?? [];
    loaded = true;
  };

  const resolve = async (reqId, decision) => {
    const res = await groupsApi.resolveInvitation(reqId, decision);
    if (!res?.error) {
      invitations.value = invitations.value.filter((inv) => inv.id !== reqId);
    }
    return res;
  };

  const reset = () => {
    invitations.value = [];
    error.value = "";
    loaded = false;
  };

  return { invitations, loading, error, count, load, resolve, reset };
};
